import { materialGoodsReceiptBusiness } from "api/bussiness/material/material-goods-receipt";
import {
  IControl,
  OptionItem,
} from "commons/ultilities/dynamic-form/models/control";
import { useCallback } from "react";

interface UseGoodsIssueItemHandlersParams {
  getBrandControl: (rowIndex: number) => IControl;
}

export const useGoodsIssueItemHandlers = ({
  getBrandControl,
}: UseGoodsIssueItemHandlersParams) => {
  const updateBrandOptionsByMaterial = useCallback(
    async (rowIndex: number, materialId?: string | null) => {
      const brandCtr = getBrandControl(rowIndex);
      if (!brandCtr) return;

      if (!materialId) {
        brandCtr.setProp("optionItems", []);
        brandCtr.setValueAndValidate("");
        return;
      }

      const brandOptions =
        await materialGoodsReceiptBusiness.getReceiptedBrandOptions(materialId);
      brandCtr.setProp("optionItems", brandOptions as OptionItem[]);
    },
    [getBrandControl],
  );

  const itemValueChangedHandler = useCallback(
    async (control: IControl, rowIndex: number) => {
      if (control.name !== "materialId") return;
      await updateBrandOptionsByMaterial(rowIndex, control.value);
    },
    [updateBrandOptionsByMaterial],
  );

  return {
    updateBrandOptionsByMaterial,
    itemValueChangedHandler,
  };
};
